import loadable from "@loadable/component";
import Loader from "./Loader";

const LazyLoad = (importFunc, fallback) => {
  return loadable(importFunc, {
    fallback: fallback || <Loader />,
  });
};

export default LazyLoad;
